<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Limit Config</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Limit Config</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'EWLimitConfigList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <table class="table table-responsive">
                  <thead>
                  <tr>
                    <th>SL</th>
                    <th>Previous Data</th>
                    <th>Current Data</th>
                    <th>Changed By</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(log,i) in value">
                    <td>{{i+1}}</td>
                    <td>{{JSON.parse(log.previous_data)}}</td>
                    <td>{{JSON.parse(log.current_data)}}</td>
                    <td>{{log.user}}</td>

                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import axios from 'axios'
import {Notification} from 'element-ui'

const fileDownload = require("js-file-download")


export default {
  name: 'EWLimitConfigShow',
  metaInfo: {
    title: 'Limit Config | Dotlines'
  },
  data: () => ({
    value: {},
    pre: {
      trx_activity_type: [],
    },
    is_loading: false
  }),
  mounted: function () {
    this.initialize()
  },
  methods: {
    trxActivityTypeOptions: function () {
      return new Promise(resolve => {
        axios.get("/get-dropdown-options/1")
          .then(response => {
            resolve(response.data)
          })
          .catch((error) => {
            console.error('error ' + error)
            resolve(error)
          })
      })
    },

    async initialize() {
      this.is_loading = true
      this.params = this.$route.params

      await this.trxActivityTypeOptions().then(trx_activity_type => {
        this.pre.trx_activity_type = trx_activity_type
      })


      await this.getDetail(this.params.id).then(response => {
        this.value = response.data
        // console.log(this.value)
      });

      this.is_loading = false
    },
    downloadFile: function (url) {
      this.is_loading = true
      axios.get(this.API_ASSET_UPLOAD_URL + url, {responseType: "arraybuffer"})
        .then(response => {
          fileDownload(response.data, url.replaceAll("/", "-"))
          Notification.success({
            title: 'Download Completed',
            message: 'Download completed successfully',
            type: 'success'
          })
        })
        .catch(error => {
          Notification.error({title: 'Download Failed', message: 'Failed to download', type: 'error'})
        })
        .finally(() => {
          this.is_loading = false
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line camelcase
        const api_url = '/getLimitConfigLogs/'+id;
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            console.log('error ' + error)
            reject(error)
          })
          .finally(() => {
          });
      })
    },
  },
}
</script>
